import { invertMap } from '@/sections/insights/queryBuilder/entities/common/invert';
import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
  getValueFromQueryFilter,
  getValueFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

const valueMap: Record<string, string> = {
  tcp: 'TCP',
  udp: 'UDP',
};

const valueMapInverse = invertMap(valueMap);

/**
 * Reusable field definition for Port protocol
 * Translates between API codes (tcp/udp) and UI values (TCP/UDP)
 */
export const PortProtocol: SimpleFilterDefinition = {
  apiField: 'protocol',
  uiField: 'Protocol',
  inputType: 'dropdown',
  getAvailableValues: () => Promise.resolve(['TCP', 'UDP']),
  operators: ['is', 'is not'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'Protocol',
      operator: getOperatorFromQueryFilter(queryFilter),
      value: getValueFromQueryFilter(valueMap, queryFilter),
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    return {
      field: 'protocol',
      operator: getOperatorFromSimpleFilter(simpleFilter),
      value: getValueFromSimpleFilter(valueMapInverse, simpleFilter),
      not: getNotFromSimpleFilter(simpleFilter),
    };
  },
};
